export default {"src":"/_next/static/media/billing-systems.8d0bf83e.svg","height":512,"width":384,"blurWidth":0,"blurHeight":0};